import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Container } from 'src/app/shared/models/container.types';
import { DeleteService } from 'src/app/shared/services/delete.service';
import { MatDialog } from '@angular/material/dialog';

const DEFAULT_PROFILE_IMAGE = 'assets/img/card-icons/default-profile-image.jpg';

const DEFAULT_ITEM_IMAGE = 'assets/img/card-icons/default-item.svg';

export abstract class Card {
    readonly cardTypeTranslationKey: string;
    navigationUrl: string;
    navigationUrlParams?: { [key: string]: any };
    deleteCardService: DeleteService;
    router: Router;
    dialog: MatDialog;
    options?: CardOptions;

    public constructor(
        public itemId: string,
        public userId: string,
        public userName: string,
        public footer: CardFooter,
        public picture?: string,
        public rootObj?: Container
    ) {
        this.itemId = itemId;
        this.userId = userId;
        this.userName = userName;
        this.footer = footer;
        this.rootObj = rootObj;

        if (!!picture) {
            this.picture = picture;
        } else {
            this.picture = DEFAULT_ITEM_IMAGE;
        }
    }

    public abstract deleteCard(): Observable<unknown>;

    public abstract onCardPictureClick(): void;
}

export class CardFooter {
    constructor(
        public title: string,
        public userProfilePicture: string
    ) {
        userProfilePicture
            ? (this.userProfilePicture = userProfilePicture)
            : (this.userProfilePicture = DEFAULT_PROFILE_IMAGE);
    }
}

export class CardOptions {
    constructor(
        public hideDeleteButton: boolean = false,
        public disableDeleteButton: boolean = false,
        public isOnClickDisabled: boolean = false,
        public showPrivacyStatus: boolean = true
    ) {}
}
